import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { generateLocalSessionId } from "@/lib/utils/hashing/hash"

const fallbackSessionId = generateLocalSessionId()

export const useDepictClientSessionId = (): string =>
    useEcommerceStore(state => state.basketSession?.token || fallbackSessionId)
